import usePagination from '@/hooks/usePagination';
import { EventsFilters, SortType } from '@/types/schema';

import { useEventsQuery } from '../graphql/queries/generated/events';

function useEvents({
  sort,
  filters,
  pause = false,
  pageSize,
}: {
  sort?: SortType[] | SortType;
  filters?: EventsFilters;
  pause?: boolean;
  pageSize?: number;
}) {
  const { data, isFetchingMore, error, refetch, fetchMore, isFetching, isLoading, totalCount } =
    usePagination(
      useEventsQuery,
      {
        filters,
        sort,
      },
      {
        edgeKey: 'events',
        requestPolicy: 'cache-and-network',
        pause,
        pageSize,
      },
    );

  return {
    isFetching,
    isFetchingMore,
    isLoading,
    error,
    events: data,
    totalCount,
    refetch,
    fetchMore,
  };
}

export default useEvents;
